import React, { useState, useRef, useEffect } from "react";
import IconDropDown from "./icons/iconDropDown";
import classNames from "classnames";

 
function CustomSelect({ options = [], value, onChange, placeholder = "Select",
   styleInput='text-[#D1D1FF] h-[48px] ' , styleSlect='bottom-full',
    label, sizeTexte='text-[18px]',isOpen, setIsOpenListeAgent, id,
    isRequired
  }) 
    {
  const [open, setOpen] = useState(isOpen || false);
  const [icon, setIcon]= useState()
  const ref = useRef(null);
  const normalizedOptions= options.map((opt)=>
    typeof opt ==='object'
    ? opt 
    :
    {value:opt,
    label:opt
    })

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
        if(!value){
           setOpen(false)}
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
 
  const selected = normalizedOptions.find((opt) => opt.value === value);

  return (
   <div ref={ref} className={classNames(sizeTexte,'relative')}>

  {label && <label className="pl-2 mb-2 text-[#422EAE]  font-bold flex items-start">
    {label} {isRequired && <span className='text-[#EE443F] ml-2'>*</span>}
  </label>}

  <div
    onClick={() => setOpen(!open)}
    className={classNames(styleInput,'relative z-10 border border-[#AEB6FB]  rounded-[16px] bg-white px-2 flex items-center justify-between cursor-pointer ')}
  >
    <span className={`${selected ? "text-[#35258B] " : "text-[#D1D1FF]"} flex items-center gap-2`}>
    {icon &&  <img src={icon} alt="drapeau"/> }
      {selected ? selected.label : placeholder}
    </span>
    <IconDropDown   className={`transition-transform duration-200 ${open ? 'rotate-180 text-[#5754E5]' : 'text-[#AEB6FB]' }`}/>

  </div>

  {open && (
    <div className={` ${styleSlect} absolute z-[9999] left-0 w-full bg-white shadow-lg rounded-[6px]  max-h-[250px] overflow-auto `}>
      {normalizedOptions.map((opt, index) => (
        <div
          key={index}
          onClick={() => {
            onChange(opt.value, id);
            setIcon(opt.icon)
            setOpen(false);
          }}
          className={`h-[40px] flex items-center gap-2 pl-2 cursor-pointer  font-medium  text-[#35258B] hover:text-[#4D36CC] ${
            value === opt.value ? "bg-[#F1F1FF] text-[#5754E5]" : ""
          }`}
        >
          {opt.icon && <img src={opt.icon} alt="drapeau"/>}
          {opt.label}
        </div>
      ))}
    </div>
  )}
</div>
  );
}

export default CustomSelect;